package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.Res
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.cat_auto_services
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.cat_beauty_wellness
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.cat_community_services
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.cat_education_tutors
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.cat_events_entertainment
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.cat_finance_accounting
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.cat_food_restaurants
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.cat_grocery_specialty_food
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.cat_home_services
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.cat_legal_services
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.cat_medical_health
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.cat_moving_storage
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.cat_real_estate
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.cat_shopping
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.resources.cat_technology_services
import org.jetbrains.compose.resources.DrawableResource

/**
 * Category id → illustrated ("cartoonish") category image. The current set is Microsoft
 * **Fluent Emoji 3D** (MIT license — see docs/DESIGN_SYSTEM.md § Category imagery), downscaled
 * to 192px. Swapping the art style is a 1:1 file replacement in `composeResources/drawable/`
 * (`cat_<categoryId>.png`); null = category has no image yet and callers fall back to the
 * static Material Symbols icon.
 */
fun categoryImageRes(categoryId: String): DrawableResource? = when (categoryId) {
    "food_restaurants" -> Res.drawable.cat_food_restaurants
    "medical_health" -> Res.drawable.cat_medical_health
    "beauty_wellness" -> Res.drawable.cat_beauty_wellness
    "legal_services" -> Res.drawable.cat_legal_services
    "finance_accounting" -> Res.drawable.cat_finance_accounting
    "real_estate" -> Res.drawable.cat_real_estate
    "education_tutors" -> Res.drawable.cat_education_tutors
    "auto_services" -> Res.drawable.cat_auto_services
    "home_services" -> Res.drawable.cat_home_services
    "grocery_specialty_food" -> Res.drawable.cat_grocery_specialty_food
    "events_entertainment" -> Res.drawable.cat_events_entertainment
    "shopping" -> Res.drawable.cat_shopping
    "community_services" -> Res.drawable.cat_community_services
    "moving_storage" -> Res.drawable.cat_moving_storage
    "technology_services" -> Res.drawable.cat_technology_services
    else -> null
}
